export const LANGUAGE_SELECTION_DROPDOWN_COPY = {
  prompt: 'Select Language',
  label: 'Language',
};
